export const kycLabels = [
  { value: '', label: 'All' },
  { value: 'APPROVED', label: 'Host' },
  // { value: 'PENDING', label: 'Pending' },
  { value: 'REJECTED', label: 'Player' },
  // { value: 'REQUESTED', label: 'Requested' },
  // { value: 'RE_REQUESTED', label: 'Re Requested' }
]


export const DeletedStatus = [
  { value: '', label: 'Filter by Deleted Status' },
  { value: true, label: 'Deleted' },
  // { value: 'PENDING', label: 'Pending' },
  { value: false, label: 'Not Deleted' },
  // { value: 'REQUESTED', label: 'Requested' },
  // { value: 'RE_REQUESTED', label: 'Re Requested' }
]

export const PlayerStatus = [
  { value: '', label: 'Filter by Player Status' },
  { value: true, label: 'Active' },
  // { value: 'PENDING', label: 'Pending' },
  { value: false, label: 'In Active' },
  // { value: 'REQUESTED', label: 'Requested' },
  // { value: 'RE_REQUESTED', label: 'Re Requested' }
]

// export const tableHeaders = [
//   { label: 'Id', value: 'userId' },
//   { label: 'UserName', value: 'username' },
//   { label: 'Email', value: 'email' },
//   //   { label: 'First Name', value: 'firstName' },
//   //   { label: 'Date Of Birth', value: 'dateOfBirth' },
//   { label: 'Phone Number', value: 'phoneNumber' },
//   { label: 'User Notes', value: 'profileNotes' },
//   { label: 'Status', value: 'status' },
//   {label: 'Joining Date', value: 'joiningDate'},
//   {label: 'Registration Source', value: 'registrationSource'},
//   // { label: 'host', value: 'host' },
//   // { label: 'is internal', value: 'is internal' },
//   //   { label: 'affiliate name', value: 'affiliate name' },
//   //   { label: 'affiliate status', value: 'affiliate status' },
//   { label: 'action', value: 'action' }
// ]


export const tableHeaders = [
  { label: 'Id', value: 'userId', accessor: 'userId', Header: 'Id' },
  { label: 'UserName', value: 'username', accessor: 'username', Header: 'UserName' },
  { label: 'Email', value: 'email', accessor: 'email', Header: 'Email' },
  { label: 'Phone Number', value: 'phoneNumber', accessor: 'phone', Header: 'Phone Number' },
  { label: 'User Notes', value: 'profileNotes', accessor: 'profileNotes', Header: 'User Notes' },
  { label: 'Status', value: 'status', accessor: 'isActive', Header: 'Status' },
  { label: 'Affiliate Status', value: 'affiliateStatus', accessor: 'affiliateStatus', Header: 'Affiliate Status' },
  { label: 'Joining Date', value: 'joiningDate', accessor: 'joiningDate', Header: 'Joining Date' },

  { label: 'Promo Code', value: 'promoCode', accessor: 'promoCode', Header: 'Promo Code' },

  { label: 'Registration Source', value: 'registrationSource', accessor: 'registrationSource', Header: 'Registration Source' },
  { label: 'Action', value: 'action', accessor: 'action', Header: 'Action' }
];
// email,
// 								isActive,
// 								userId,
// 								username,
// 								phone,
// 								other,
// 								created_at,
// 								isSuspicious,
// 								isVerified,